import React, { useEffect, useState } from 'react'
import KonfhubContainer from '../../../revampComponents/Atom/Container'
import { ASSET_LABELS, ASSET_TYPE_MAPPING, ASSET_TYPE_REVERSE_MAPPING, ASSET_TYPES, assetValidationSchema, buildAssetPayload } from './AssetLibraryConstant';
import { useParams, useHistory, useLocation } from "react-router-dom";
import { dashboardColors, theme } from '../../../themes/Theme';
import backbtn from '../../../assets/images/back-btn.svg';
import AddNEditAsset from './AddNEditAsset';
import { useFormik } from 'formik'
import * as Yup from 'yup'
import _ from 'lodash'
import customToast from '../../../components/common/basic/Toast';
import { getUTCDateNTime } from '../../../Utils/helpers';
import { cleanPayload } from '../TaskManagement/TaskManagementConstant';
import { diffAndCommon } from '../../../services/util';
import { CrudMessages, ErrMessages } from '../../EventInfo/config/error-constants';
import { errorToaster, removeEmptyValues } from '../../../reusable/common';
import { createAsset, getAssetById, updateAsset } from '../../../revampCRUD/asset.library.crud';
import LoadingSpinner from '../../../revampComponents/Atom/Loading';

const AddNEditAssetInterface = (props) => {
    const { eventId, assetId } = useParams()
    const [isEdit, setIsEdit] = useState(!!assetId)
    const [loading, setLoading] = useState(false)
    const [isExhibitorToggle, setIsExhibitorToggle] = useState(true)
    const history = useHistory()

    const getInitialAssetDetails = () => ({
        task_type: "",
        title: "",
        description: "",
        files: [],
        category_ids: [],
        exhibitor_ids: [],
        task_category_id: '',
    })

    const [assetDetails, setAssetDetails] = useState(getInitialAssetDetails())
    const [editCategorIds, setEditCategoryIds] = useState([]);

    
    const formik = useFormik({
        initialValues: {
            task_type: "",
            title: "",
            description: "",
            files: [],
            asset_link: "",
            task_column_mapping: "custom_task",
            auto_assign_type: null,
            category_ids: [],
            exhibitors: {
                items: [],
                _original: []
            },
            categories: {
                items: [],
                _original: []
            }
        },
        validationSchema: assetValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = removeEmptyValues(buildAssetPayload(values, isEdit, props?.eventInfo?.time_zone));

                let response;
                if (isEdit) {
                    response = await updateAsset(assetId, payload);
                } else {
                    response = await createAsset(payload);
                }

                if (response?.data) {
                    customToast.success(
                        isEdit ? `Asset ${CrudMessages.UPDATE_MESSAGE}` : `Asset ${CrudMessages.ADDED_MESSAGE}`
                    );
                    formik.resetForm();
                    history.push(`/e/${eventId}/exhibitor-portal/asset-library`);
                } else {
                    customToast.error(ErrMessages.DEFAULT_ERROR_MESSAGE);
                }
            } catch (err) {
                const errorMessage = err?.response?.data?.message ||
                    err?.response?.data?.error ||
                    ErrMessages.DEFAULT_ERROR_MESSAGE;
                customToast.error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
    });

    useEffect(() => {
        if (!assetId) return;

        setLoading(true);
        setIsEdit(true);

        const fetchAssetData = async () => {
            try {
                const response = await getAssetById(assetId);
                const fetchedAssetData = response?.data?.tasks || [];
                const asset = fetchedAssetData?.find((t) => t?.task_id === assetId);

                if (asset) {
                    const {
                        exhibitors,
                        category_ids,
                        task_type,
                        ...otherDetails
                    } = asset;

                    const mappedTaskType = ASSET_TYPE_REVERSE_MAPPING[task_type] || task_type;

                    const exhibitorItems = (exhibitors || [])?.map(e => ({
                        id: e?.id,
                        entity_name: e?.entity_name
                    }));

                    formik.setValues({
                        ...otherDetails,
                        task_type: mappedTaskType,
                        category_ids: category_ids || [],
                        exhibitors: {
                            items: exhibitorItems,
                            _original: JSON.parse(JSON.stringify(exhibitorItems))
                        },
                        categories: {
                            items: [],
                            _original: []
                        }
                    });

                    if (category_ids && category_ids?.length > 0) {
                        setIsExhibitorToggle(false);
                    } else {
                        setIsExhibitorToggle(true);
                    }

                    setLoading(false);
                }
            } catch (error) {
                customToast.error('Error loading asset data');

                if (error?.response?.status === 404) {
                    history.push(`/e/${eventId}/exhibitor-portal/asset-library`);
                }
                setLoading(false);
            }
        };

        fetchAssetData();
    }, [assetId]);


    const handleShareTypeToggle = (isExhibitor) => {
        setIsExhibitorToggle(isExhibitor)
       
    }
    return (
        <div>
         {loading ? <LoadingSpinner /> :
            <KonfhubContainer>
                <h4 className="px-sm-4 px-2 pt-2 asset-library-edit-add-title mb-0 mb-sm-2">
                    <img src={backbtn} alt="Back" className="richtext-cursor-pointer mr-2" onClick={() => {
                        history.push(`/e/${props?.eventInfo?.event_id}/exhibitor-portal/asset-library`);
                    }} />
                    {isEdit ? ASSET_LABELS?.EDIT_ASSET : ASSET_LABELS?.CREATE_ASSET}
                </h4>

                <AddNEditAsset
                    formik={formik}
                    isEdit={isEdit}
                    assetTypes={ASSET_TYPES}
                    eventInfo={props?.eventInfo}
                    loading={loading}
                    isExhibitorToggle={isExhibitorToggle}
                    setIsExhibitorToggle={setIsExhibitorToggle}
                    onShareTypeToggle={handleShareTypeToggle}
                    props={props}
                     setEditCategoryIds={setEditCategoryIds}
                     setLoading={setLoading}
                     assetDetails={assetDetails}
                />

                <style>{`
                    .asset-library-edit-add-title {
                        color: ${dashboardColors[theme].primaryTextColor};
                        font-weight: 600;
                        font-size: 18px;
                    }
                `}</style>
            </KonfhubContainer>
         }
        </div>
    )
}

export default AddNEditAssetInterface
